import i18next from "i18next";
import StatusPill from "../../../components/Common/ListParts/StatusPill";
import { convertDoubleToCurrencyPTBR } from "../../../../utils/ConverterUtils";
import { bonusSituation, monthLabel } from "./bonusMonth";

// Quem recebe. É a pergunta que a tela responde, então vem primeiro.
const employeeRenderer = (params) => params.data?.employee?.name || '-';

// Valor de cada mês, e não o total da vigência.
const valueRenderer = (params) => convertDoubleToCurrencyPTBR(params.data?.value);

const startRenderer = (params) => monthLabel(params.data?.startMonth);

// Fim vazio quer dizer que vale até o gestor encerrar; "-" daria a impressão de dado faltando.
const endRenderer = (params) => params.data?.endMonth
    ? monthLabel(params.data.endMonth)
    : i18next.t('cash_flow.employee_bonus_no_end');

// Tom pela situação no mês corrente: vigente em verde, a começar em âmbar e encerrada
// apagada, como as demais listagens do financeiro.
const SITUATION_TONE = { active: 'paid', upcoming: 'pending', ended: 'canceled' };

const situationRenderer = (params) => {
    if (!params.data) {
        return '-';
    }
    const situation = bonusSituation(params.data);
    return (
        <StatusPill tone={SITUATION_TONE[situation]}>
            {i18next.t(`cash_flow.employee_bonus_${situation}`)}
        </StatusPill>
    );
};

const branchRenderer = (params) => params.data?.branch?.name || '-';

// Colunas do grid de bonificações.
export const Columns = [
    {
        headerName: 'employee',
        field: 'employee.name',
        cellRenderer: employeeRenderer,
        sortable: false,
        width: 230
    },
    {
        headerName: 'cash_flow.employee_bonus_value',
        field: 'value',
        cellRenderer: valueRenderer,
        width: 150
    },
    {
        headerName: 'cash_flow.employee_bonus_start_month',
        field: 'startMonth',
        cellRenderer: startRenderer,
        width: 130
    },
    {
        headerName: 'cash_flow.employee_bonus_end_month',
        field: 'endMonth',
        cellRenderer: endRenderer,
        width: 130
    },
    {
        headerName: 'cash_flow.employee_bonus_situation',
        field: 'startMonth',
        colId: 'situation',
        cellRenderer: situationRenderer,
        sortable: false,
        width: 130
    },
    {
        headerName: 'description',
        field: 'description',
        filter: true
    },
    {
        headerName: 'branch',
        field: 'branch.name',
        cellRenderer: branchRenderer,
        sortable: false,
        width: 170
    }
];
